// extracted by css-extract-rspack-plugin
export default {"forgotPasswordText":"LoginPage_forgotPasswordText__uguQp","noAccountYet":"LoginPage_noAccountYet__w8w5B","loginFormFooter":"LoginPage_loginFormFooter__9DxfS"};